<template>
  <div>
    <main-layout>
      <div>
        <v-container>
          <div v-if="currentView == 'list'">
            <InputSearch
              class="mb-3"
              @clickAdvancedSearch="showSearch = true"
              @clickSearch="onSearch"
              @clearSearch="clearSearch"
              :search="search"
              showDateSearch
              :placeholder="$t('broadcast message search placeholder')"
            />
            <v-layout row wrap dense class="mb-3">
              <v-flex xs6 style="display: flex; align-items: center">
                <Typography h2 bold :label="$t('Broadcast')" />
              </v-flex>
              <v-flex xs6 style="display: flex; align-items: flex-end; justify-content: flex-end">
                <div class="text-xs-right" style="display: flex; align-items: flex-end">
                  <v-btn
                    variant="outlined"
                    v-tooltip="$t('Add')"
                    :loading="loading"
                    icon
                    color="#BECCDB"
                    style="border-radius: 50% !important"
                    @click="showAddBroadcast = true"
                  >
                    <img
                      src="/static/img/Add.png"
                      alt
                      class="responsive-img"
                      style="height: 20px"
                    />
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
            <v-layout class="my-5" justify-center v-if="loading">
              <v-progress-circular
                :size="100"
                :width="10"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-layout>
            <div v-else>
              <v-data-table
                expand
                hide-actions
                :items="all_broadcasts"
                :loading="loading"
                :headers="headers"
                item-key="name"
                class="fixTable"
              >
                <!-- :items="[...draft_broadcasts, ...schedule_broadcasts, ...sent_broadcasts]" -->
                <template v-slot:headers="props">
                  <tr style="background-color: #152d53; color: white">
                    <th
                      style="background-color: #152d53; color: yellow"
                      v-for="header in props.headers"
                      v-show="showColumn.includes(header.text) || header.text == ''"
                      :key="header.text"
                      :width="header.width"
                    >
                      <div v-show="showColumn.includes(header.text)">{{ header.text }}</div>
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <td v-show="showColumn.includes('วันที่ / เวลา')" class="text-xs-left">
                    <Typography
                      style="width: 140px"
                      h5
                      :label="props.item.createdtime | DateFormat('DD/MM/YYYY HH:mm')"
                    />
                  </td>

                  <td v-show="showColumn.includes('สถานะ')" class="text-xs-center">
                    <v-chip
                      v-if="props.item.status === 'draft'"
                      color="#BDBDBD"
                      text-color="white"
                      small
                      disabled
                      style="width: 70px; justify-content: center"
                      >DRAFT</v-chip
                    >
                    <v-chip v-else color="#52C41A" text-color="white" small disabled
                      >BROADCASTED</v-chip
                    >
                  </td>
                  <td v-show="showColumn.includes('บรอดแคสต์')" class="text-xs-left">
                    <Typography
                      style="width: 700px; padding: 10px 0px"
                      h5
                      :label="props.item.name"
                    />
                  </td>
                  <td v-show="showColumn.includes('สร้างโดย')" class="text-xs-left">
                    <Typography h5 :label="props.item.createdby" />
                  </td>
                  <td style="white-space: nowrap" @click.stop="">
                    <TooltipTable
                      v-if="props.item.status === 'draft'"
                      :datas="props"
                      @modalEdit="editBroadcast(props.item)"
                      @Copy="copyBroadcast(props.item, 'draft')"
                      @Delete="deleteBroadcast(props.item.id, props.item.name)"
                      showCopy
                      showDelete
                    ></TooltipTable>
                    <TooltipTable
                      v-else
                      :datas="props"
                      :showIsEdit="false"
                      @View="viewBroadcast(props.index)"
                      @Copy="copyBroadcast(props.item, 'draft')"
                      showCopy
                      showView
                    ></TooltipTable>
                  </td>
                </template>
              </v-data-table>
            </div>
            <Paginations
              @clickPagination="changepage"
              @sortPage="sortPage"
              :pageCount="pagelength"
              :numberPage="numberPage"
              :page="page"
            />
          </div>

          <div v-if="currentView == 'edit'">
            <template v-if="currentView == 'edit'">
              <broadcast-manage
                @onClose="onClose"
                :value="selected_edit_broadcast"
                @onSave="onSave"
                :broadcastType="'draft'"
              ></broadcast-manage>
            </template>
          </div>
          <div v-if="currentView == 'view'">
            <template v-if="selected_view_broadcast">
              <broadcast-view @onClose="onClose" :value="selected_view_broadcast"></broadcast-view>
            </template>
          </div>
          <add-broadcast
            v-if="showAddBroadcast"
            @close="showAddBroadcast = false"
            @onSave="onSave"
          ></add-broadcast>
        </v-container>
      </div>
    </main-layout>
  </div>
</template>

<script>
import InputSearch from '@/components/elements/InputSearch.vue'
import Typography from '@/components/elements/Typography.vue'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import Paginations from '@/components/elements/Paginations.vue'
import BroadcastManage from './BroadcastManage'
import BroadcastView from './BroadcastView'
import AddBroadcast from './AddBroadcast'
import api from '@/api'
import { mapGetters } from 'vuex'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import moment from 'moment'
import BroadcastItem from './BroadcastItem.vue'

export default {
  data: function () {
    return {
      copy_name: '',
      sent_name: '',
      isSave: false,
      pageloading: false,
      isCopy: false,
      currentView: 'list',
      isFail: false,
      draft_broadcasts: [],
      sent_broadcasts: [],
      schedule_broadcasts: [],
      all_broadcasts: [],
      selected_edit_broadcast: undefined,
      selected_view_broadcast: undefined,
      showAddBroadcast: false,
      loading: true,
      page: 1,
      numberPage: {
        page: undefined,
      },
      pagination: {
        sortBy: 'memberid',
        descending: false,
        rowsPerPage: 10,
      },
      pagetmp: 1,
      pagetotal: 0,
      offset: 1,
      limit: 10,
      search: {
        nameAll: '',
        date: null,
      },
      showSearch: false,
      headers: [
        {
          text: 'วันที่ / เวลา',
          align: 'center',
          value: 'date_time',
        },
        {
          text: 'สถานะ',
          align: 'center',
          value: 'status',
        },
        {
          text: 'บรอดแคสต์',
          align: 'center',
          value: 'name',
        },
        {
          text: 'สร้างโดย',
          align: 'center',
          value: 'create',
        },
        {
          text: '',
          align: 'center',
          value: '',
        },
      ],
      showColumn: ['วันที่ / เวลา', 'สถานะ', 'บรอดแคสต์', 'สร้างโดย'],
    }
  },
  components: {
    BroadcastManage,
    BroadcastView,
    ScaleLoader,
    BroadcastItem,
    InputSearch,
    Typography,
    TooltipTable,
    Paginations,
    AddBroadcast,
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
    }),
    pagelength() {
      if (this.pagetotal) {
        return Math.ceil(this.pagetotal / 10)
      } else {
        return 1
      }
    },
  },
  mounted: async function () {
    var vm = this
    if (vm.$store.state.shoptheme.includes(vm.selectedBot.theme)) {
      vm.$store.dispatch('loadCategory').then(function () {
        vm.$store.dispatch('loadProducts')
      })
      vm.$store.dispatch('loadCharges')
    }
    vm.$store.dispatch('loadSetting')
    vm.loading = true
    vm.getBroadcast(function () {
      vm.loading = false
      resolve()
    })
    vm.$store.dispatch('loadStatus')
  },
  methods: {
    async onSearch() {
      var vm = this
      this.searchloading = true
      this.searchloading = false
      this.showSearch = false
      vm.pageloading = true
      vm.loading = true
      if (vm.search.nameAll !== '' || vm.search.date !== null) {
        vm.getBroadcastSearch(function () {
          vm.loading = false
        })
      } else if (vm.search.nameAll === '' || vm.search.date === null) {
        vm.loading = true
        vm.all_broadcasts = []
        vm.getBroadcast(function () {
          vm.loading = false
        })
      }
    },
    async clearSearch() {
      this.search = { projectname: '', projecteffdate: '', projectenddate: '' }
      this.searchloading = true
      this.searchloading = false
      this.showSearch = false
    },
    async changepage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        this.page = val
        this.all_broadcasts = []
        this.numberPage.page = undefined
        vm.loading = true
        vm.getBroadcast(function () {
          vm.loading = false
        })
      }
    },
    async sortPage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        this.page = val
        this.numberPage.page = undefined
        this.all_broadcasts = []
        vm.getBroadcast(function () {
          vm.loading = false
        })
      }
    },
    onClose: async function (payload) {
      var vm = this
      vm.currentView = 'list'
      vm.loading = true
      vm.getBroadcast(function () {
        vm.loading = false
      })
    },
    getBroadcast: function (callback) {
      var vm = this
      vm.offset = vm.page * 10 - 10
      if (vm.page != 1) {
        vm.offset + 1
      }
      vm.pageloading = true
      var data = {}
      data = { pageid: vm.selectedBot.pageid, limit: vm.limit, offset: vm.offset }
      api.getBroadcast(data, function (error, response) {
        if (error) {
          console.error(error)
          callback()
          return
        }
        vm.pageloading = false
        if (response.data) {
          vm.pagetotal = parseInt(response.total)
          vm.all_broadcasts.length = 0
          $.each(response.data, function (index, broadcast) {
            vm.all_broadcasts.push(broadcast)
          })
        }
        callback()
      })
    },
    getBroadcastSearch: function (callback) {
      var vm = this
      vm.offset = vm.page * 10 - 10
      if (vm.page != 1) {
        vm.offset + 1
      }
      var search = {}
      for (const [key, value] of Object.entries(this.search)) {
        if (key === 'date') {
          Object.assign(search, { [key]: value ? moment(value).format('YYYY-MM-DD') : '' })
        } else {
          Object.assign(search, { [key]: value })
        }
      }
      var data = {}
      vm.all_broadcasts = []
      data = {
        pageid: vm.selectedBot.pageid,
        ...search,
      }
      api.getBroadcast(data, function (error, response) {
        if (error) {
          console.error(error)
          callback()
          return
        }
        vm.pageloading = false
        if (response.data) {
          vm.pagetotal = 1
          vm.all_broadcasts.length = 0
          $.each(response.data, function (index, broadcast) {
            vm.all_broadcasts.push(broadcast)
          })
        }
        callback()
      })
    },
    editBroadcast: function (broadcasts) {
      $('html, body').animate({ scrollTop: 0 })
      this.selected_edit_broadcast = broadcasts
      this.currentView = 'edit'
      this.all_broadcasts = []
    },
    viewBroadcast: function (index) {
      $('html, body').animate({ scrollTop: 0 })
      var vm = this
      this.selected_view_broadcast = this.all_broadcasts[index]
      vm.$nextTick(function () {
        vm.currentView = 'view'
        vm.all_broadcasts = []
      })
    },
    deleteBroadcast: function (broadcastid, broadcastname) {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete draft?', {
            name: broadcastname.replace(/\<|\>/g, ''),
          }),
          // type: 'question',
          imageUrl: '/static/img/DeleteModal.png',
          imageWidth: 100,
          imageHeight: 100,
          imageAlt: 'Custom image',
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            vm.$store.dispatch('loading')
            api.deleteBroadcast(
              { pageid: vm.selectedBot.pageid, broadcastid: broadcastid },
              function (error, response) {
                if (error) {
                  console.error(error)
                  // vm.loading = true
                  return
                }

                $.each(vm.all_broadcasts, function (index, broadcast) {
                  if (broadcast.id == broadcastid) {
                    vm.all_broadcasts.splice(index, 1)
                    return false
                  }
                })
                vm.$store.dispatch('loading')
              }
            )
          }
        })
    },
    onSave: function (payload) {
      var vm = this
      vm.saveBroadcast(payload.data, function (status, id) {
        payload.onSave(status, id)
        vm.showAddBroadcast = false
        vm.editBroadcast(payload.data)
      })
    },
    copyBroadcast: function (payload, type) {
      var vm = this
      var data = null

      var broadcast = null
      if (payload == null) return false
      broadcast = vm.all_broadcasts.find((el) => {
        return el.id == payload.id
      })
      if (broadcast) data = Object.assign({}, { ...broadcast, status: 'draft' })
      if (data == null) return false
      vm.$swal
        .fire({
          title: vm.$t('Do you want to copy {name}?', { name: data.name.replace(/\<|\>/g, '') }),
          type: 'question',
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            data.id = null
            data.name += ' copy'
            ;(data.sendflag = false),
              (data.page_access_token = vm.selectedBot.page_access_token),
              (vm.copy_name = data.name)
            vm.$store.dispatch('loading')
            vm.saveBroadcast(data, function (status, id) {
              if (status) {
                data.id = id
                vm.all_broadcasts.unshift(data)
                vm.$swal.fire({
                  title: vm.$t('Broadcast {copy_name} copy', {
                    copy_name: data.name.replace(/\<|\>/g, ''),
                  }),
                  type: 'success',
                  confirmButtonText: vm.$t('Confirm'),
                  cancelButtonText: vm.$t('cancel'),
                  reverseButtons: true,
                })
                vm.$store.dispatch('loading')
              }
              vm.$store.dispatch('loading')
            })
          }
        })
    },
    saveBroadcast: function (data, callback) {
      let vm = this
      api.updateBroadcast(data, function (error, response) {
        if (error) {
          console.error(error)
          callback(false, null)
          return
        }
        var id = null
        if (response.broadcastid) {
          id = response.broadcastid
        }
        callback(true, id)
        vm.$store.dispatch('loading')
      })
    },
  },
}
</script>


<style lang="scss" scoped>
//for fix column table by Tada
.fixTable table.v-table {
  thead {
    tr {
      th:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      th:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
  tbody {
    tr {
      td:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        background-color: #ffffff;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      td:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/broadcast/Broadcast.vue